<section class="page-center-card p-2">
  <div class="card">
    <div class="card-body">
      <label for="e1">Cliente</label>
      <select [formControl]="form.controls.unidadeCliente" id="e1" class="form-control">
        <option value="">Selecione</option>
        <option value="0">**CLIENTE AVULSO</option>
        <option *ngFor="let o of listaUnidades" [value]="o.id">{{o.nomefantasia}}</option>
      </select>
      <app-msg-erro [control]="form.controls.unidadeCliente"></app-msg-erro>
      
      <label class="mt-4" for="e2">Tipo de Vistoria</label>
      <select [formControl]="form.controls.tipoVistoria" id="e2" class="form-control">
        <option value="">{{ form.value.unidadeCliente== '' ? 'Selecione uma unidade' : 'Selecione'}}</option>
        <option *ngFor="let o of listaTipoLaudo" [value]="o.id">{{o.nome}}</option>
      </select>
      <app-msg-erro [control]="form.controls.tipoVistoria"></app-msg-erro>
        <div class="d-flex">
        <label class="m-5">Habilitar integração HG ?</label>
        <p-selectButton class="selectButton" [options]="stateOptions" [(ngModel)]="desejaIntegrar" (onChange)="desejaIntegrarHg()" optionLabel="label" optionValue="desejaIntegrar"></p-selectButton>
      </div>
      <div *ngIf="desejaIntegrar" class="container">
        <div class="row justify-content-center">
          <div class="col">
            <div class="card">
              <div class="card-header">
                <!-- <h4>Login Auto Avaliar</h4> -->
              </div>
              <div class="card-body">
                <form>
                  <div class="form-group">
                    <label for="email">Nome de Usuário:</label>
                    <input #email type="email" class="form-control" id="email" ng-model="email" required>
                  </div>
                  <div class="form-group">
                    <label for="senha">Senha:</label>
                    <input #senha type="password" class="form-control" id="senha" ng-model="senha" required>
                  </div>
                  <button type="submit" (click)="authHg(email.value, senha.value)" class="btn btn-primary">Login</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="unidadeIntegra" class="d-flex">
        <label class="m-5">Deseja iniciar a vistoria com avaliação da Auto Avaliar?</label>
        <p-selectButton class="selectButton" [options]="stateOptions" [(ngModel)]="value" optionLabel="label" optionValue="value" (onChange)="carregarHg()"></p-selectButton>
      </div> -->
      <div>
        <label class="mt-4" for="e3">Placa</label>
        <input [textMask]="mask.placa" [formControl]="form.controls.placa" id="e3" type="text" class="text-uppercase form-control">
        <app-msg-erro [control]="form.controls.placa"></app-msg-erro>
      </div>
      <!-- <div *ngIf="unidadeIntegra && desejaIntegrar">
        <label class="mt-4" for="e4">Selecione a avaliação</label>
        <select id="e4" [formControl]="form.controls.placa" class="form-control">
          <option value="">Selecione</option>
          <option *ngFor="let a of avaliacoes" [value]="a.id">{{'ID ANÚNCIO: ' + a.id + ' / PLACA ANÚNCIO: ' + a.plate}}</option>
        </select>
      </div> -->
      <div class="mt-4">
        <div *ngIf="desejaIntegrar && desabilitaCriar">
          <h4 class="w-100">Realize a autenticação para prosseguir</h4>
        </div>
        <button [disabled]="desabilitaCriar" (click)="confirmar()" class="mt-3 btn btn-lg btn-success w-100">Confirmar</button>
      </div>
    </div>
  </div>
</section>